import { render } from "./AdminPlaces.vue?vue&type=template&id=2e2ab889"
import script from "./AdminPlaces.vue?vue&type=script&lang=js"
export * from "./AdminPlaces.vue?vue&type=script&lang=js"

import "./AdminPlaces.vue?vue&type=style&index=0&id=2e2ab889&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__